<template>
  <VAvatar :class="draft ? 'draft' : ''" class="deal-avatar p-1" :size="size">
    <span v-if="productType && DealIcons[productType]" class="d-flex items-center justify-center p-0!">
      <FpSvgIcon :src="DealIcons[productType]" />
    </span>
  </VAvatar>
</template>

<script setup lang="ts">
import { DealIcons, } from '@/commons/dictionaries/DealIcons';
import { computed } from 'vue';
import FpSvgIcon from '@/components/fpComponents/FpSvgIcon.vue';

const props = withDefaults(defineProps<{
  productType: string;
  size?: string;
  draft?: boolean;
}>(), {
  size: '40px',
  draft: false,
});

const color = computed(() => {
  switch (props.productType) {
    case 'productTypeMortgage':
      return 'mortgage';
    case 'productTypeCash':
      return 'cash';
    case 'productTypeSme':
    case 'productTypeSmeFactoring':
    case 'productTypeSmeLeasing':
      return 'sme';
    case 'productTypeRealEstate':
      return 'realEstate';
    case 'productTypeInsurance':
    case 'productTypeInsuranceLife':
    case 'productTypeInsuranceMedical':
    case 'productTypeInsuranceVehicle':
    case 'productTypeInsuranceAssets':
      return 'insurance';
    default:
      return 'mortgage';
  }
});

const bgColor = computed(() => {
  return `var(--token-${color.value}-surface)`;
});

const baseColor = computed(() => {
  return `var(--token-${color.value}-base)`;
});

const iconColor = computed(() => {
  return `var(--token-${color.value}-text)`;
});

</script>

<style lang="scss" scoped>
.deal-avatar {
  --border-color: v-bind(baseColor);
  border: 1px solid color(from var(--border-color) srgb r g b / 0.24) !important;

  &:not(.draft) {
    --bg-color: v-bind(bgColor);
    --icon-color: v-bind(iconColor);
    background-color: var(--bg-color);
  }
  &.draft {
    border-style: dashed !important;
    --icon-color: v-bind(baseColor);
  }

  :deep(svg) {
    *:not([stroke]) {
      fill: var(--icon-color) !important;
    }
    *[stroke] {
      stroke: var(--icon-color) !important;
    }
  }
}
</style>


